export class certificate{
    /**
     *
     */
    constructor() {

    }
    org_id:any;
    public id:any
    public data:any;
}